// dropdownMenu.js
export function dropdownMenu() {
    const dropdownItems = document.querySelectorAll('.nav__item--dropdown');
    const pageOverlay = document.querySelector('.page-overlay');
    const BREAKPOINT = 1024;

    let mode = null; // 'hover' | 'click'

    function closeDropdowns() {
        dropdownItems.forEach(item => item.classList.remove('is-open'));
    }

    function closeAll() {
        closeDropdowns();
        if (pageOverlay) pageOverlay.classList.remove('page-overlay--active');
    }

    function setMode() {
        const newMode = window.innerWidth >= BREAKPOINT ? 'hover' : 'click';
        if (newMode === mode) return;

        closeAll();
        mode = newMode;

        dropdownItems.forEach(item => {
            const toggle = item.querySelector('.nav__link--toggle');
            const backBtn = item.querySelector('.nav-dropdown__back');
            if (!toggle) return;

            /* cleanup */
            item.onmouseenter = null;
            item.onmouseleave = null;
            toggle.onclick = null;
            if (backBtn) backBtn.onclick = null;

            /* ----------------------------- */
            /* DESKTOP: HOVER                */
            /* ----------------------------- */
            if (mode === 'hover') {
                item.onmouseenter = () => {
                    item.classList.add('is-open');
                    if (pageOverlay) pageOverlay.classList.add('page-overlay--active');
                };

                item.onmouseleave = () => {
                    item.classList.remove('is-open');
                    if (pageOverlay) pageOverlay.classList.remove('page-overlay--active');
                };
            }

            /* ----------------------------- */
            /* MOBILE: CLICK                 */
            /* ----------------------------- */
            if (mode === 'click') {
                toggle.onclick = e => {
                    e.preventDefault();
                    const isOpen = item.classList.contains('is-open');

                    closeDropdowns();

                    if (!isOpen) {
                        item.classList.add('is-open');
                        if (pageOverlay) pageOverlay.classList.add('page-overlay--active');
                    }
                };

                if (backBtn) {
                    backBtn.onclick = e => {
                        e.preventDefault();
                        closeDropdowns(); // 👈 overlay blijft actief
                    };
                }
            }
        });
    }

    /* overlay click = alles sluiten */
    if (pageOverlay) {
        pageOverlay.addEventListener('click', closeAll);
    }

    setMode();
    window.addEventListener('resize', setMode);
}
